module.exports = __webpack_public_path__ + "static/media/parts.1.e8580606.png";